import "@/App.css";
import MatchPage from "@/pages/MatchPage";
import { Toaster } from "@/components/ui/sonner";

function App() {
  return (
    <div className="App">
      <MatchPage />
      <Toaster position="top-center" />
    </div>
  );
}

export default App;
